export default __webpack_public_path__ + "img/3-befcd235.png";